import { ServiceRequestSearchResultResponseDto } from './service-request-search-result-response.dto';

export class ServiceRequestSearchResponseDto {
  docs: ServiceRequestSearchResultResponseDto[];
  nextPage: number;
}
